const ManageCoupen = {
  getCoupon: {
    url: "/coupon",
    method: "GET",
  },
  addCoupon: {
    url: "/coupon",
    method: "POST",
  },
  updateCoupon: (id) => ({
    url: `/coupon/${id}`,
    method: "PUT",
  }),
  DeleteCoupon: (id) => ({
    url: `/coupon/${id}`,
    method: "DELETE",
  }),
  getCouponById: (id) => ({
    url: `/coupon/${id}`,
    method: "GET",
  }),
  updateCoupenStatus: (id) => ({
    url: `/coupon/change-status/${id}`,
    method: "PUT",
  }),
  usedCoupen: (id) => ({
    url: `/coupon-consumption/${id}`,
    method: "GET",
  }),
};
export default ManageCoupen;
